module.exports = __webpack_public_path__ + "img/xp-2015.ff8ea547.png";